<template>
    <div :class="{'col-md-12':true,'m-top-20':properties.length > 0}">
        <div v-for="(property,index) of properties" :key="index">
            <customer-property :customer-id="customer.customer_id" :country-code="countryCode" :date-format="dateFormat"
                               :property="property" :country-key="countryKey"
                               :booking-id="bookingId"></customer-property>
        </div>
    </div>
</template>

<script>

import {getCustomerProperties} from "@/modules/CustomerProperties/api"
import {EventBus} from "@/events/event-bus";

export default {
    name: "CustomerProperties",
    props: {
        value: {
            default() {
                return []
            }
        },
        tradingId: null,
        dateFormat: null,
        countryCode: null,
        bookingId: null,
        type: null,
        countryKey: null,
        customer: null
    },
    data() {
        return {
            properties: this.value,
            billPayerProperty: null
        }
    },
    methods: {
        updateCustomerProperties(from_trading_name = 0, bill_payer_value = 0) {
            if (this.customer&&this.customer.customer_id) {
                let typeValue = this.type;
                if(typeValue &&typeValue !== 'inquiry'){
                    typeValue = 'booking';
                }
                getCustomerProperties(this.customer?.customer_id, this.tradingId
                    , this.bookingId, typeValue)
                    .then(async response => {
                        this.properties = response.data;
                        if (response && response.data){
                            this.billPayerProperty = response.data.filter(property => property.core_id === 1);
                        }
                        this.$forceUpdate();
                        if (!from_trading_name) {
                            EventBus.$emit('onBillPayerChanged', bill_payer_value);
                        }

                    })
            }
        },
    },
    mounted() {
        window.formProperties = this.properties

        // EventBus.$on('onCustomerChanged',  (item,bill_payer_value) => {
        //     if (item){
        //         this.customer = item;
        //         if (this.customer.default_bill_payer){
        //             bill_payer_value = this.customer.default_bill_payer;
        //         }
        //         this.updateCustomerProperties(0,bill_payer_value);
        //
        //     }
        // });

        EventBus.$on('onBillPayerChanged', value => {
            if (value) {
                // Check if properties array has an item with core_id equal to 1
                const hasPropertyWithCoreIdOne = this.properties.some(property => property.core_id === 1);
                // If there isn't an item with core_id of 1, then concat the billPayerProperty
                if (!hasPropertyWithCoreIdOne) {
                    this.properties = this.properties.concat(this.billPayerProperty);
                }
            } else {
                this.properties = this.properties.filter(property => property.core_id !== 1);
            }
        });

    },
    watch: {
        tradingId(id) {
            this.updateCustomerProperties(1);
        },
        customer(item) {
          if (item){
            console.log(item)
            this.updateCustomerProperties(0,item.default_bill_payer??0);

          }
        },
        properties: {
            handler(properties) {
                this.$emit('input', properties)
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style scoped>

</style>
